// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.mHead-h[data-v-746fbb4e] {\n  width: 100%;\n  background: #000;\n}\n\n/*安卓手机通用的状态栏高度*/\n.mHead[data-v-746fbb4e] {\n  top: 0;\n  width: 100%;\n  left: 0;\n  position: fixed;\n  z-index: 5;\n  background: #000;\n}\n\n/*ios手机可以设置为安全区域的高度*/", ""]);
// Exports
module.exports = exports;
